import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { Link as RouterLink } from "react-router-dom";
import ProductPreview from "features/landing/components/ProductPreview";
import { contentWidth, eyebrow, plannerButton } from "features/landing/landingStyles";

export default function HeroSection() {
  return (
    <Box
      component="section"
      aria-labelledby="landing-title"
      sx={{ bgcolor: "dark.main", color: "white.main" }}
    >
      <Box sx={{ ...contentWidth, pt: { xs: 6, md: 10 }, pb: { xs: 5, md: 8 } }}>
        <Box sx={{ maxWidth: 850, mx: "auto", textAlign: "center" }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 3 }}
          >
            <Box
              aria-hidden="true"
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                bgcolor: "accent.main",
                flexShrink: 0,
              }}
            />
            <Typography component="p" sx={{ ...eyebrow, color: "grey.300" }}>
              RUTINAS LISTAS EN MUY POCO TIEMPO
            </Typography>
          </Stack>
          <Typography
            id="landing-title"
            component="h1"
            sx={{
              color: "inherit",
              fontWeight: 700,
              fontSize: { xs: "2.5rem", sm: "3.5rem", md: "4.5rem" },
              lineHeight: 1.06,
              letterSpacing: "-0.055em",
            }}
          >
            Crea rutinas de entrenamiento en minutos.
          </Typography>
          <Typography
            sx={{
              maxWidth: 560,
              mx: "auto",
              mt: 3,
              color: "grey.300",
              fontSize: { xs: "1rem", md: "1.125rem" },
              lineHeight: 1.7,
            }}
          >
            Elige los ejercicios, arrástralos al planner y ajusta los detalles. Pasa de una idea a
            una rutina completa sin perder tiempo.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            justifyContent="center"
            sx={{ mt: 4, mb: { xs: 6, md: 9 } }}
          >
            <Button
              component={RouterLink}
              to="/planner/new"
              variant="contained"
              color="primary"
              endIcon={<ArrowRight size={18} aria-hidden="true" />}
              sx={plannerButton}
            >
              Crear una rutina
            </Button>
            <Button
              component={RouterLink}
              to="/programs"
              sx={{ ...plannerButton, color: "white.main", "&:hover": { bgcolor: "dark.focus" } }}
            >
              Ver mis rutinas
            </Button>
          </Stack>
        </Box>
        <ProductPreview />
      </Box>
    </Box>
  );
}
